import GoldenSynagogue from './GoldenSynagogue/GoldenSynagogue';
import ClassicWood from './ClassicWood/ClassicWood';
import MarbleWhite from './MarbleWhite/MarbleWhite';
import DarkNavy from './DarkNavy/DarkNavy';
import DigitalClassic from './DigitalClassic/DigitalClassic';
import DigitalLarge from './DigitalLarge/DigitalLarge';

const templates = {
  GoldenSynagogue,
  ClassicWood,
  MarbleWhite,
  DarkNavy,
  DigitalClassic,
  DigitalLarge,
};

export default templates;
